import React from 'react';
import { Steps } from 'antd';
import ConnectTiktokStep from 'modules/apps/apps/TiktokApp/components/TiktokConnectionFlow/ConnectTiktokStep';
import ActivateTiktokAccountsStep from 'modules/apps/apps/TiktokApp/components/TiktokConnectionFlow/ActivateTiktokAccountsStep';
import SetUpTiktokAccountsStep from 'modules/apps/apps/TiktokApp/components/TiktokConnectionFlow/SetUpTiktokAccountsStep';
import useAccountConnectionFlow from 'components/AccountConnectionFlow/AccountConnectionFlow.provider';
import CompleteAccountConnectionFlowStep from 'components/AccountConnectionFlow/CompleteAccountConnectionFlowStep';

const TiktokConnectionFlow = (props) => {
  const flow = useAccountConnectionFlow();
  const { step } = flow;

  const steps = [
    {
      index: 0,
      name: 'connect',
      title: 'Connect to MyDataNinja',
      description: 'Give access to your tiktok ad accounts',
      content: <ConnectTiktokStep />,
    },
    {
      index: 1,
      name: 'choose_accounts',
      title: 'Choose Accounts',
      description: 'Which you want to work with',
      content: <ActivateTiktokAccountsStep />,
    },
    {
      index: 2,
      name: 'set_up',
      title: 'Set Up Accounts',
      description: 'Configure tracking and other settings',
      content: <SetUpTiktokAccountsStep />,
    },
    {
      index: 3,
      name: 'complete',
      title: 'Finish',
      description: 'Ready to Go!',
      content: <CompleteAccountConnectionFlowStep />,
    },
  ];

  const findStep = (stepName) => {
    return steps.find(({ name }) => name === stepName);
  };

  const currentStep = findStep(step);

  return (
    <div className='flex flex-col'>
      <div className='w-full'>
        <Steps
          responsive={true}
          current={currentStep?.index || 0}
          items={steps.map(({ title, description }) => ({ title, description }))}
        />
      </div>
      <div className='w-full mt-4'>{currentStep?.content || 'Error loading content'}</div>
    </div>
  );
};

TiktokConnectionFlow.propTypes = {};

export default TiktokConnectionFlow;
